module.exports = __webpack_public_path__ + "img/icon-cloud-computing-white.45afe283.svg";